import { useTranslation } from 'react-i18next';

import Info from '@/assets/icons/info.svg?component';
import { Badge } from '@/components/atoms/Badge';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

export default function QualityBasisBadge() {
    const { t } = useTranslation('harvestReport', { keyPrefix: 'quality' });

    return (
        <Badge
            tone="accent"
            size="md"
            icon={<SvgIcon icon={Info} size="custom" customSize={14} color="currentColor" />}>
            {t('basedOnWounds')}
        </Badge>
    );
}
